import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { buildBreadcrumbList } from '../lib/structuredData';
import { DownloadIcon } from 'lucide-react';
export function AlgemeneVoorwaardenPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="w-full min-h-screen bg-white text-[#111827] font-sans" data-id="element-785" data-mp="3qceupre14fej">
      <SEO title="Algemene Voorwaarden | Noord Digital" description="Lees de algemene voorwaarden en Service Level Agreement (SLA) van Noord Digital." canonical="https://noorddigital.nl/algemene-voorwaarden" jsonLd={buildBreadcrumbList([{
      name: 'Algemene Voorwaarden',
      path: '/algemene-voorwaarden'
    }])} data-id="element-786" data-mp="3bkedeijnhgge" />
      <Header data-id="element-787" data-mp="37hq1u33jxvfq" />

      <main className="pt-32 pb-20" data-id="element-788" data-mp="2sn3g33hkwx3l">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[900px]" data-id="element-789" data-mp="2so4qr6uonhks">
          <div className="flex flex-col md:flex-row md:items-center justify-between mb-12 gap-6" data-id="element-790" data-mp="2xm68nogdhauo">
            <h1 className="text-4xl md:text-5xl font-bold text-[#111827]" data-id="element-791" data-mp="cwlgnwvldgl6">
              Algemene Voorwaarden
            </h1>
            <a href="#" className="inline-flex items-center justify-center bg-[#007AFF] hover:bg-[#005FCC] text-white font-semibold py-3 px-6 rounded-lg transition-colors whitespace-nowrap" data-id="element-792" data-mp="7xs0txsu1dhu">
              <DownloadIcon className="w-5 h-5 mr-2" data-id="element-793" data-mp="hxsofvxqifru" />
              Download PDF
            </a>
          </div>

          <div className="prose prose-lg max-w-none prose-headings:text-[#111827] prose-a:text-[#007AFF] prose-p:text-[#6B7280] prose-li:text-[#6B7280]" data-id="element-794" data-mp="3qcsrkqylq3hs">
            <h2 className="text-3xl font-bold mt-12 mb-6 border-b pb-4" data-id="element-795" data-mp="2zqixg757k7y">
              ALGEMENE VOORWAARDEN EN SLA
            </h2>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-796" data-mp="3ud312dllrc1e">
              Artikel 1: Definities
            </h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-797" data-mp="36mqrkyapl78p">
              <li data-id="element-798" data-mp="32n8bqgxqvmcq">
                <strong data-id="element-799" data-mp="32lnh6rbfk3ev">Noord Digital:</strong> de vennootschap onder firma
                Noord Digital, gevestigd te Oudkarspel, ingeschreven bij de KvK
                onder nummer 96071044.
              </li>
              <li data-id="element-800" data-mp="1ajuezg3a86ci">
                <strong data-id="element-801" data-mp="1ajca5v2k0jsz">Opdrachtgever of klant:</strong> iedere natuurlijke
                persoon of rechtspersoon die diensten van Noord Digital afneemt
                of met Noord Digital een overeenkomst sluit.
              </li>
              <li data-id="element-802" data-mp="mngekm4sjqud">
                <strong data-id="element-803" data-mp="mnzxa529mj9g">Partijen:</strong> gezamenlijk Noord Digital en de
                Opdrachtgever.
              </li>
              <li data-id="element-804" data-mp="rn2tr146jh5t">
                <strong data-id="element-805" data-mp="rodtmpui84rn">Diensten:</strong> alle door Noord Digital aangeboden
                werkzaamheden en services, waaronder webdesign,
                websiteontwikkeling, WordPress- en Elementor-websites, hosting,
                onderhoud, SEO-optimalisatie, e-mailhosting, domeinregistratie,
                branding, API-ontwikkeling, AI-workflows en
                software-implementaties.
              </li>
              <li data-id="element-806" data-mp="1caqprnjhgre">
                <strong data-id="element-807" data-mp="1cskmhmqbiw5">Overeenkomst:</strong> het geheel van schriftelijke
                afspraken tussen Partijen, bestaande uit (i) de door
                Opdrachtgever ondertekende offerte of opdrachtbevestiging, (ii)
                deze Algemene Voorwaarden, en (iii) alle aan de Opdrachtgever
                geleverde documenten en materialen die onderdeel uitmaken van de
                opdracht.
              </li>
              <li data-id="element-808" data-mp="3duh0hvffkxoc">
                <strong data-id="element-809" data-mp="3dv0jzgkqbu4h">Schriftelijk:</strong> omvat alle vormen van
                communicatie per e-mail of elektronische handtekening. Een
                elektronische handtekening die voldoet aan de eIDAS-verordening
                (Verordening (EU) 910/2014) wordt geacht een handgeschreven
                handtekening te zijn.
              </li>
              <li data-id="element-810" data-mp="132623i0ni0ny">
                <strong data-id="element-811" data-mp="130l57lqv65mx">Werkdag:</strong> elke dag van maandag tot en met
                vrijdag, uitgezonderd officiële Nederlandse feestdagen.
              </li>
            </ul>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-812" data-mp="3rtzslz1yzsdf">
              Artikel 2: Toepasselijkheid
            </h3>
            <p data-id="element-813" data-mp="3vv3bkufbe4iv">
              Deze Algemene Voorwaarden zijn van toepassing op alle offertes,
              aanbiedingen, werkzaamheden en overeenkomsten tussen Noord Digital
              en de Opdrachtgever. Dat geldt ook indien tussentijds (na
              totstandkoming) een of meerdere aanvullende verklaringen door
              partijen zijn ondertekend; de oorspronkelijke voorwaarden blijven
              leidend.
            </p>
            <p data-id="element-814" data-mp="3czd3qqkpadx2">
              Wijzigingen of aanvullingen op deze voorwaarden gelden slechts
              indien uitdrukkelijk schriftelijk overeengekomen. Tegenstrijdige
              voorwaarden van de Opdrachtgever worden hierbij uitdrukkelijk van
              de hand gewezen. Indien de Opdrachtgever zich niet akkoord
              verklaart met deze Algemene Voorwaarden, dient hij dit
              onmiddellijk, maar uiterlijk bij ondertekening van de offerte of
              opdrachtbevestiging aan Noord Digital te melden.
            </p>
            <p data-id="element-815" data-mp="26kffy84siep6">
              De Opdrachtgever verklaart bij het aangaan van de Overeenkomst
              kennis te hebben genomen van deze Algemene Voorwaarden en hiermee
              akkoord te gaan. Indien partijen een digitaal offerte- of
              ondertekeningsproces gebruiken, moet de Opdrachtgever via een
              expliciete klik of handtekening bevestigen dat hij de Algemene
              Voorwaarden heeft ontvangen (bijvoorbeeld als pdf) en kan opslaan
              voor latere raadpleging. Alleen op deze wijze is voldaan aan de
              eis dat voorwaarden vóór of bij contractsluiting kenbaar en "ter
              hand gesteld" moeten worden.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-816" data-mp="3d71349mob81c">
              Artikel 3: Offertes en totstandkoming van de Overeenkomst
            </h3>
            <p data-id="element-817" data-mp="386my70gdce7j">
              Alle offertes en prijsopgaven van Noord Digital zijn vrijblijvend,
              tenzij uitdrukkelijk anders vermeld. Een offerte bevat een
              omschrijving van de overeengekomen werkzaamheden, tarieven en,
              indien van toepassing, oplevertermijn.
            </p>
            <p data-id="element-818" data-mp="3u0txmimcbwnn">
              Een Overeenkomst komt uitsluitend tot stand op het moment dat: (i)
              de Opdrachtgever de offerte of opdracht schriftelijk accepteert
              (bijvoorbeeld door ondertekening of elektronische bevestiging),
              (ii) Noord Digital de opdracht schriftelijk bevestigt, of (iii)
              Noord Digital met de uitvoering van werkzaamheden aanvangt. Het is
              niet vereist dat de Opdrachtgever de inhoud van de Algemene
              Voorwaarden leest voordat hij akkoord gaat. Wel moeten de Algemene
              Voorwaarden bij contractsluiting als bijlage of hyperlink
              beschikbaar zijn gesteld zodat de Opdrachtgever ze kan downloaden
              en bewaren (art. 6:235 BW). Bij digitale totstandkoming
              (bijvoorbeeld online opdrachtbevestiging) dient dit via een
              duidelijk herkenbare link of pdf bij de Overeenkomst te
              geschieden.
            </p>
            <p data-id="element-819" data-mp="21cmcar119wdw">
              Indien een offerte of opdrachtbevestiging handelt over
              verschillende deelonderdelen of -fasen, is elk onderdeel pas
              overeengekomen (en verschuldigd) als de Opdrachtgever ook daarvoor
              aan Noord Digital opdracht geeft.
            </p>
            <p data-id="element-820" data-mp="2ozuciujluf92">
              Na het sluiten van de Overeenkomst kan de Opdrachtgever zonder
              toestemming van Noord Digital niet eenzijdig (onder)delen van het
              project wijzigen of delegeren aan derden.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-821" data-mp="18nxhf9qkmnal">
              Artikel 4: Uitvoering van de Overeenkomst
            </h3>
            <p data-id="element-822" data-mp="13n12m14olgqe">
              Noord Digital zal de Overeenkomst naar beste inzicht en vermogen
              uitvoeren. Dit betekent onder meer dat een inspanningsverplichting
              geldt voor de overeengekomen werkzaamheden en dat alle redelijke
              stappen worden gezet om het project succesvol te laten verlopen.
            </p>
            <p data-id="element-823" data-mp="1oddcc6pfi54f">
              Alle door Noord Digital gecommuniceerde (oplever)termijnen zijn
              streefdata en niet bindend, tenzij uitdrukkelijk schriftelijk
              anders overeengekomen. Eventuele sancties bij overschrijding van
              termijnen (zoals boetes) zijn niet van toepassing, tenzij dit
              schriftelijk is overeengekomen.
            </p>
            <p data-id="element-824" data-mp="27chjf9xetotg">
              Indien de Opdrachtgever niet op tijd informatie, content (teksten,
              afbeeldingen, video's, ontwerpen, etc.) of goedkeuring aanlevert,
              of als het project vertraging oploopt door gebrek aan
              besluitvorming of wijzigingen in de scope, kan dit leiden tot
              vertraging van het project. In een dergelijk geval zal Noord
              Digital in overleg met de Opdrachtgever de planning aanpassen.
            </p>
            <p data-id="element-825" data-mp="jcvx86z5qgay">
              Indien Noord Digital bij de uitvoering derden inschakelt (zoals
              hostingproviders, softwareleveranciers of freelancers), geschiedt
              dit voor eigen rekening en risico, tenzij anders vermeld in de
              Offerte.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-826" data-mp="5h1mrjiqjivq">
              Artikel 5: Oplevering en acceptatie
            </h3>
            <p data-id="element-827" data-mp="fd4wbafx2jsp">
              De overeengekomen diensten of producten (bijvoorbeeld een website,
              applicatie of ontwerp) gelden als opgeleverd zodra Noord Digital
              de Opdrachtgever schriftelijk of per e-mail heeft bericht dat de
              werkzaamheden zijn afgerond, dan wel zodra het project feitelijk
              is gepubliceerd of in gebruik genomen door de Opdrachtgever.
            </p>
            <p data-id="element-828" data-mp="3h5rt8ra016o2">
              Na oplevering heeft de Opdrachtgever maximaal 14 dagen de tijd om
              schriftelijk gebreken of bezwaren te melden. De melding moet
              duidelijk aangeven welke onderdelen niet voldoen aan de
              afgesproken specificaties.
            </p>
            <p data-id="element-829" data-mp="32hdryks8dq9m">
              Indien de Opdrachtgever binnen deze termijn geen schriftelijke en
              gespecificeerde bezwaren indient, wordt de oplevering geacht te
              zijn geaccepteerd. Na deze acceptatie is Noord Digital niet meer
              verplicht kostenloos wijzigingen aan te brengen buiten de reeds
              overeengekomen scope.
            </p>
            <p data-id="element-830" data-mp="2jhztbpjk3rcs">
              Na acceptatie vallende wijzigingen, aanvullingen of verbeteringen
              onder meerwerk (artikel 7) tenzij sprake is van een aan Noord
              Digital toerekenbaar verborgen gebrek dat reeds bij oplevering
              bestond.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-831" data-mp="p9vyyx1tzo7d">
              Artikel 6: Verplichtingen van de Opdrachtgever
            </h3>
            <p data-id="element-832" data-mp="u7xi1hz9bniu">
              De Opdrachtgever is verantwoordelijk voor tijdige en volledige
              aanlevering van alle benodigde materialen en informatie,
              waaronder:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-833" data-mp="13xqvkoiymcpq">
              <li data-id="element-834" data-mp="6b1lrsi0mvtb">Teksten, afbeeldingen, video's en andere content;</li>
              <li data-id="element-835" data-mp="6cuvjgnxdw5j">Bedrijfsgegevens en logo's;</li>
              <li data-id="element-836" data-mp="b9la1zk30jou">
                Toegang tot (test)omgevingen, beheerdersaccounts en systemen
                (inloggegevens voor hosting, CMS, API's, etc.);
              </li>
              <li data-id="element-837" data-mp="l8anng4y3hza">
                Tussentijdse feedback en goedkeuringen. Indien deze gegevens
                niet tijdig worden verstrekt, kan de planning worden aangepast
                zoals in artikel 4.3 staat beschreven.
              </li>
            </ul>
            <p data-id="element-838" data-mp="1wlmorj9blmhr">
              De Opdrachtgever garandeert dat alle door hem aangeleverde
              materialen vrij zijn van rechten van derden (auteursrechten,
              portretrechten, merkenrechten, e.d.). Bij het gebruik van
              afbeeldingen, teksten, video's of muziek moet de Opdrachtgever de
              nodige licenties of toestemmingen hebben. Indien hiervoor kosten
              aan verbonden zijn, draagt de Opdrachtgever deze kosten.
            </p>
            <p data-id="element-839" data-mp="3a0w37h8n6szq">
              De Opdrachtgever vrijwaart Noord Digital volledig tegen alle
              aanspraken van derden, boetes, kosten en schadeclaims die
              voortvloeien uit door de Opdrachtgever aangeleverde of
              goedgekeurde content, websites of systemen. Dit omvat onder meer
              claims op grond van: auteursrechtinbreuk, merkenrecht,
              portretrecht, privacy/bescherming persoonsgegevens (AVG), cookie-
              of reclameregels, misleidende bewoordingen, of andere
              onrechtmatige inhoud. Ook eventuele kosten voor juridische
              verdediging komen voor rekening van de Opdrachtgever, tenzij
              duidelijk sprake is van grove nalatigheid of opzet van Noord
              Digital.
            </p>
            <p data-id="element-840" data-mp="229guko7lco3b">
              De Opdrachtgever is zelf verantwoordelijk voor de inhoud en het
              juridische gebruik van de opgeleverde website of software
              (bijvoorbeeld privacybeleid, cookieverklaringen, disclaimers).
              Noord Digital kan de opdrachtgever adviseren of informeren, maar
              is niet aansprakelijk voor naleving van regelgeving of
              effectiviteit van marketing/SEO.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-841" data-mp="2pxzxeo7vg8o0">
              Artikel 7: Wijzigingen en meerwerk
            </h3>
            <p data-id="element-842" data-mp="19j8f544fwhsf">
              Alle werkzaamheden die buiten de oorspronkelijk overeengekomen
              opdracht vallen, gelden als meerwerk. Dit geldt onder meer voor:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-843" data-mp="1uppov694zrco">
              <li data-id="element-844" data-mp="1urai8sjpt48y">
                Extra functionaliteiten of plug-ins die niet in de
                oorspronkelijke opdrachtomschrijving zijn opgenomen;
              </li>
              <li data-id="element-845" data-mp="1l17mwlp4fe7g">
                Nieuwe pagina's of secties op een website die niet waren
                begrepen in de oorspronkelijke briefing;
              </li>
              <li data-id="element-846" data-mp="2dok4ehgfcvtw">
                Aanvullende integraties met externe systemen of koppelingen
                (bijv. met CRM's, betaalproviders) die niet vooraf waren
                gespecificeerd;
              </li>
              <li data-id="element-847" data-mp="23puqt0vk9xjg">
                Herhaalde revisierondes bovenop de in de Overeenkomst
                afgesproken revisielimiet.
              </li>
            </ul>
            <p data-id="element-848" data-mp="sbhaqi71umdz">
              Meerwerk wordt alleen uitgevoerd na voorafgaande schriftelijke
              instemming van de Opdrachtgever. Noord Digital zal aan de
              Opdrachtgever een nieuwe offerte of wijzigingsofferte sturen voor
              dit meerwerk, met een indicatie van de aanvullende kosten en
              (indien van toepassing) een nieuwe oplevertermijn. De
              Opdrachtgever dient deze offerte schriftelijk te accepteren
              voordat het meerwerk wordt verricht.
            </p>
            <p data-id="element-849" data-mp="3dox835knag40">
              Revisies of aanpassingen die binnen de oorspronkelijke scope
              vallen worden kosteloos uitgevoerd. Indien echter naar het oordeel
              van Noord Digital het aantal verzoeken buitensporig wordt of
              duidelijk buiten de overeengekomen scope valt, is Noord Digital
              gerechtigd deze werkzaamheden als meerwerk te factureren.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-850" data-mp="gsudvmyjwy3">Artikel 8: Betaling</h3>
            <p data-id="element-851" data-mp="1xb75k396bzwh">
              Voor projecten hanteert Noord Digital de volgende
              betalingsstructuur (exclusief btw):
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-852" data-mp="229qpjy47j1m7">
              <li data-id="element-853" data-mp="1u8116y17bsun">
                Projecten boven €2.000: 30% bij opdrachtbevestiging en start van
                de werkzaamheden; 70% bij oplevering.
              </li>
              <li data-id="element-854" data-mp="246yt8axu64ie">
                Projecten tot €2.000: 100% voorafgaand aan aanvang van de
                werkzaamheden.
              </li>
            </ul>
            <p data-id="element-855" data-mp="1z6aypfaef5jf">
              Facturen worden verzonden op het moment van opdrachtbevestiging of
              oplevering, afhankelijk van het hierboven bepaalde schema.
              Betaling dient te geschieden binnen 14 dagen na factuurdatum,
              tenzij schriftelijk anders is overeengekomen.
            </p>
            <p data-id="element-856" data-mp="2mzaxj381vfv6">
              Bij niet-tijdige betaling is de Opdrachtgever van rechtswege in
              verzuim. Noord Digital is vanaf dat moment bevoegd wettelijke
              handelsrente in rekening te brengen (conform art. 6:119a BW).
              Tevens komen alle redelijke buitengerechtelijke incassokosten voor
              rekening van de Opdrachtgever (volgens de Wet normering
              buitengerechtelijke incassokosten).
            </p>
            <p data-id="element-857" data-mp="3fin6267j49nu">
              In geval van wanbetaling behoudt Noord Digital zich het recht voor
              om alle openstaande werkzaamheden en diensten (inclusief hosting,
              onderhoud en support) per direct op te schorten totdat de betaling
              is voldaan. Dit betekent onder meer dat een website offline kan
              worden gehaald en dat toegang tot systemen wordt geblokkeerd. De
              Opdrachtgever blijft niettemin aansprakelijk voor de volledige
              overeengekomen vergoeding, inclusief in het werk gestoken uren.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-858" data-mp="2nttp269aysd7">
              Artikel 9: Abonnementen, looptijd en opzegging
            </h3>
            <p data-id="element-859" data-mp="28xktpfsj8z62">
              Hosting-, onderhouds- en andere periodieke diensten worden
              aangeboden op abonnementsbasis. De minimale looptijd van elk
              abonnement is 12 maanden, ingaande op de startdatum zoals vermeld
              in de offerte.
            </p>
            <p data-id="element-860" data-mp="2pbsbxxggv0lx">
              Na afloop van de initiële looptijd wordt het abonnement
              stilzwijgend verlengd voor onbepaalde tijd. Vanaf dat moment kan
              het abonnement door beide partijen maandelijks worden opgezegd met
              inachtneming van een opzegtermijn van één maand, tenzij
              schriftelijk anders is overeengekomen. Een opzegging dient
              schriftelijk of per e-mail te geschieden.
            </p>
            <p data-id="element-861" data-mp="21kmxnmq6cgdq">
              Bij tussentijdse beëindiging door de Opdrachtgever (bijvoorbeeld
              door opzegging voor het einde van de eerste jaarcontractperiode)
              blijft Noord Digital gerechtigd de overeengekomen bedrag(en) voor
              het resterende deel van de minimale contractduur (12 maanden) in
              rekening te brengen, tenzij partijen anders overeenkomen. Reeds
              betaalde abonnementskosten worden niet gerestitueerd.
            </p>
            <p data-id="element-862" data-mp="1hisb3lgkpout">
              Betaling van abonnementskosten geschiedt per automatische incasso
              of periodieke facturatie (verrekening), zoals overeengekomen in de
              offerte. Bij opzegging wordt geen terugbetaling verleend voor
              resterende looptijd, tenzij partijen anders schriftelijk zijn
              overeengekomen.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-863" data-mp="ystw0lecyvho">
              Artikel 10: Hosting en infrastructuur
            </h3>
            <p data-id="element-864" data-mp="13rn94cpqgkhb">
              Hosting door Noord Digital geschiedt via externe
              infrastructuurpartners en servers. De aangeboden hosting heeft een
              streef-uptime van 99,5% per maand. Deze uptime is echter geen
              harde garantie, maar een kwaliteitsdoelstelling.
            </p>
            <p data-id="element-865" data-mp="g1aw4nfmrxjv">
              Uptime-onderbrekingen door de volgende oorzaken vallen niet onder
              onze verantwoordelijkheid, en hebben derhalve geen recht op
              compensatie of claims: gepland onderhoud, netwerkstoringen, uitval
              van datacenters of cloudproviders, storingen bij gebruikte
              CDN-diensten (bijv. Cloudflare), DNS-problemen buiten onze
              control, of storingen in software van derden (bijv.
              hostingbeheerpanelen).
            </p>
            <p data-id="element-866" data-mp="1plqu53xdok6l">
              Noord Digital is niet aansprakelijk voor storingen veroorzaakt
              door externe partners of infrastructuur. Wel zullen wij bij
              meldingen van storingen direct onderzoeken of er aan onze kant
              ingegrepen kan worden.
            </p>
            <p data-id="element-867" data-mp="23d5bz7fjufc2">
              Voor het registreren van domeinnamen en e-mailadressen treden wij
              slechts op als tussenpersoon. De Opdrachtgever blijft zelf
              verantwoordelijk voor het rechtmatig gebruik en tijdige verlenging
              van domeinen. Noord Digital kan niet aansprakelijk worden gesteld
              voor verlopen, geweigerde of betwiste domeinnamen (tenzij wij
              grove onzorgvuldigheid hebben begaan bij de aanvraag).
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-868" data-mp="u9r62tpl3o3k">
              Artikel 11: Back-ups en dataverlies
            </h3>
            <p data-id="element-869" data-mp="pe3jmm2hl91r">
              Noord Digital maakt dagelijks automatische back-ups van websites
              en bijbehorende data die op haar hostingomgeving staan. Deze
              back-ups worden tijdelijk bewaard en dienen als extra
              voorzorgsmaatregel.
            </p>
            <p data-id="element-870" data-mp="ancrfcwzg7y4">
              Het maken van back-ups is een hulpmiddel en vormt géén garantie
              voor compleet herstel. De Opdrachtgever blijft te allen tijde zelf
              verantwoordelijk voor het veiligstellen van zijn eigen data en
              content (bijvoorbeeld via eigen opslag of versiebeheer).
            </p>
            <p data-id="element-871" data-mp="3j5dg3lv7ih8v">
              In geval van een technisch probleem of fout in de hostingomgeving
              van Noord Digital zal herstel van de meest recente back-up worden
              uitgevoerd. Daarbij geldt dat herstel slechts valt onder de
              verplichtingen van Noord Digital indien de oorzaak volledig binnen
              eigen systeem lag.
            </p>
            <p data-id="element-872" data-mp="3e7u3eqe5qcj1">
              Indien dataverlies of -beschadiging is veroorzaakt door
              handelingen of nalatigheden van de Opdrachtgever, door onbevoegde
              derden, of door storingen buiten onze infrastructuur (zoals eigen
              mailservers, externe databases, client-side opslag, etc.), dan kan
              herstel worden uitgevoerd als meerwerk tegen het gebruikelijke
              uurtarief van Noord Digital. No claims voor indirecte
              dataverliezen zijn in ieder geval uitgesloten (zie artikel 23).
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-873" data-mp="tgjroh3o2vpb">
              Artikel 12: Beveiliging en cyberincidenten
            </h3>
            <p data-id="element-874" data-mp="2e3ud2h2tmbg9">
              Noord Digital neemt redelijke technische en organisatorische
              maatregelen ter beveiliging van de door haar geleverde websites,
              applicaties en hostingomgevingen. Dit omvat standaard het gebruik
              van firewalls, SSL/TLS-certificaten, regelmatige software- en
              CMS-updates en monitoring op aanvallen.
            </p>
            <p data-id="element-875" data-mp="1v9ffmvw5qquj">
              Volledige beveiliging van internetdiensten kan echter nooit worden
              gegarandeerd. Noord Digital is daarom niet aansprakelijk voor
              schade of uitval veroorzaakt door cyberaanvallen (bijv. DDoS),
              malware, phishing, brute force-aanvallen, social engineering,
              zero-day exploits of andere (onvoorziene) inbraakmethoden.
            </p>
            <p data-id="element-876" data-mp="3blky52ixx6ig">
              Ook foutieve of achterhaalde software van derden (bijv. kwetsbare
              plugins, verouderde PHP-versies, verbreekte API-koppelingen) kan
              een risico vormen dat buiten onze verantwoordelijkheid valt.
            </p>
            <p data-id="element-877" data-mp="es8jnirr7faf">
              Indien een beveiligingsincident mede is veroorzaakt door handelen
              of nalaten van de Opdrachtgever of door ingrepen van derden
              (bijvoorbeeld installatie van niet-goedgekeurde plug-ins of
              scripts), vervalt iedere aansprakelijkheid van Noord Digital voor
              de gevolgen daarvan. Eventuele herstelwerkzaamheden kunnen als
              meerwerk worden aangeboden.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-878" data-mp="12h9jihmiti43">
              Artikel 13: Toegang en wachtwoorden
            </h3>
            <p data-id="element-879" data-mp="17fb5babbzvj9">
              De Opdrachtgever is volledig verantwoordelijk voor het beheer van
              gebruikersaccounts, rollen en wachtwoorden die hij aan derden of
              werknemers ter beschikking stelt.
            </p>
            <p data-id="element-880" data-mp="1hcfpj4lm9gxf">
              Handelingen verricht met accounts of toegangen die aan of namens
              de Opdrachtgever zijn verstrekt, komen volledig voor rekening en
              risico van de Opdrachtgever. Indien een account wachtwoorden of
              API-sleutels onveilig worden bewaard of gewist, kan de
              Opdrachtgever daarvoor niet de aansprakelijkheid bij Noord Digital
              leggen.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-881" data-mp="3knlwhammjes1">
              Artikel 14: Software en diensten van derden
            </h3>
            <p data-id="element-882" data-mp="3fp139v5shvd3">
              Bij de uitvoering van onze diensten maken wij vaak gebruik van
              software, platforms en diensten van derde partijen (bijv.
              WordPress, thema's, plug-ins, API's, AI-tools, clouddiensten,
              licentiesoftware).
            </p>
            <p data-id="element-883" data-mp="7a0lpv46e53m">
              Noord Digital kan niet aansprakelijk worden gehouden voor
              storingen, fouten, wijzigingen in werking, beveiligingslekken of
              beëindiging van dienstverlening door deze derden. Dit geldt ook
              voor incompatibiliteit, prijswijzigingen of licentieproblemen van
              software van derden.
            </p>
            <p data-id="element-884" data-mp="1myqeohubk5go">
              Eventuele kosten voor het aanschaffen of verlengen van licenties
              en abonnementen van derden kunnen separaat aan de Opdrachtgever
              worden doorberekend.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-885" data-mp="1dxij47j6tiqa">
              Artikel 15: Onderhoud
            </h3>
            <p data-id="element-886" data-mp="1i200y15zllyf">
              Het onderhoudscontract kan bestaan uit (volgens de specificaties
              in de offerte):
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-887" data-mp="18zqtjk60m8p9">
              <li data-id="element-888" data-mp="1908u2szpn92z">periodieke CMS-updates (bijv. nieuwe WordPress-versie);</li>
              <li data-id="element-889" data-mp="2yg892qq0fsqj">plugin- of thema-updates;</li>
              <li data-id="element-890" data-mp="33e007iitzato">controles op beveiliging en performance;</li>
              <li data-id="element-891" data-mp="33dhy459hm2du">
                het doorvoeren van kleine verbeteringen in content of lay-out.
              </li>
            </ul>
            <p data-id="element-892" data-mp="mrlbbrnmosyj">
              De concrete werkzaamheden en frequentie worden vastgelegd in de
              onderhoudsopdracht. Onderhoudswerkzaamheden die buiten de
              afgesproken routine vallen of waarvoor additionele content vereist
              is, worden als meerwerk beschouwd.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-893" data-mp="1agw5gqah3p3p">Artikel 16: Support</h3>
            <p data-id="element-894" data-mp="1aiz4fztlsskk">
              Onder support valt de levering van ondersteuning aan de
              Opdrachtgever op werkdagen (ma t/m vr, 09:00–17:00) voor
              technische vragen en kleine correcties.
            </p>
            <p data-id="element-895" data-mp="1ffpk4m1hxm5g">
              Support is geen 24/7-service, tenzij uitdrukkelijk schriftelijk
              anders is overeengekomen (bijvoorbeeld via een apart Service Level
              Agreement). Bij spoedstoringen zal Noord Digital weliswaar haar
              best doen snel te reageren, maar er bestaat geen garantie op
              directe bereikbaarheid of onmiddellijke oplossing buiten de
              reguliere uren.
            </p>
            <p data-id="element-896" data-mp="30boqbcuyurxt">
              Onder support vallen geen ingrijpende nieuwe functionaliteiten,
              herontwerp of uitbreiding van de overeengekomen scope. Dergelijke
              verzoeken worden als wijzigingsverzoek of meerwerk behandeld (zie
              artikel 7).
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-897" data-mp="2chexpbxhvvl8">
              Artikel 17: Intellectueel eigendom en overdracht
            </h3>
            <p data-id="element-898" data-mp="2mdrtqggiilj5">
              Alle intellectuele eigendomsrechten (zoals auteursrecht,
              databankrecht, modelrecht) op door Noord Digital gemaakte
              ontwerpen, code, structuren, concepten, documentatie en workflows
              berusten bij Noord Digital. Deze rechten omvatten met name ook
              generieke programmeercomponenten, libraries, templates, technische
              methodieken en (AI-)prompts die door Noord Digital zijn
              ontwikkeld.
            </p>
            <p data-id="element-899" data-mp="1m5tkssmlmpkg">
              De Opdrachtgever verkrijgt na volledige betaling van de
              overeengekomen prijs een niet-exclusief, niet-overdraagbaar
              gebruiksrecht voor het doel waarvoor de Overeenkomst is gesloten.
              Dit gebruiksrecht geeft de Opdrachtgever het recht om de geleverde
              website, software of content in het kader van zijn eigen
              bedrijfsvoering te gebruiken. Verdere exploitatie (zoals verkoop
              aan derden of gewijzigde inzet) is niet toegestaan zonder
              schriftelijke toestemming.
            </p>
            <p data-id="element-900" data-mp="thfp4jizg5c2">
              Tenzij nadrukkelijk anders overeengekomen, zijn Noord Digital niet
              verplicht om broncode, projectbestanden, designbestanden,
              ontwikkelomgevingen, stagingomgevingen, repositories of interne
              documentatie over te dragen aan de Opdrachtgever. Als overdracht
              van broncode is afgesproken, geldt deze pas na volledige betaling.
            </p>
            <p data-id="element-901" data-mp="394osvhl0sl5w">
              Noord Digital behoudt zich het recht voor om generieke kennis,
              elementen en (onderdelen van) code die niet specifiek voor één
              klant zijn ontwikkeld, opnieuw te gebruiken voor andere projecten.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-902" data-mp="2v5p2a4dy5w73">
              Artikel 18: Portfolio, marketing en geheimhouding
            </h3>
            <p data-id="element-903" data-mp="2q872p4ltktbr">
              Noord Digital behoudt zich het recht voor om informatie over het
              afgeronde project te gebruiken in haar portfolio, case studies en
              marketinguitingen. Dit kan onder meer het bedrijfsnaam, logo en
              screenshots van de opgeleverde website omvatten. Indien de
              Opdrachtgever hier bezwaren tegen heeft, dient dit vóór aanvang
              schriftelijk te worden gemeld; bij gebleken bezwaar kan de
              projectomschrijving worden aangepast.
            </p>
            <p data-id="element-904" data-mp="n0pvd9grhjgv">
              Partijen verplichten zich tot geheimhouding van alle
              vertrouwelijke informatie die tijdens de samenwerking wordt
              verstrekt. Vertrouwelijke informatie omvat bedrijfsgeheimen,
              klantgegevens, prijsinformatie en niet-publieke projectdetails.
              Deze geheimhoudingsplicht geldt zowel tijdens de looptijd van de
              Overeenkomst als na beëindiging daarvan.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-905" data-mp="1anekaf46uc6z">
              Artikel 19: Tevredenheidsgarantie
            </h3>
            <p data-id="element-906" data-mp="vwxl72f0zyd9">
              Noord Digital streeft naar 100% tevredenheid bij design binnen de
              oorspronkelijke scope. Kosteloze revisies worden uitgevoerd zolang
              ze betrekking hebben op aspecten die binnen het projectplan en de
              offerte vallen (zoals lay-outcorrecties, kleine functionele
              aanpassingen of taalfouten).
            </p>
            <p data-id="element-907" data-mp="239mo0yo4rgke">
              De garantie geeft geen recht op onbeperkt herontwerp of
              inhoudelijke wijzigingen van het project buiten de originele
              opdrachtomschrijving. Uitgebreide nieuwe functionaliteiten of
              strategiewijzigingen worden als meerwerk gefactureerd.
            </p>
            <p data-id="element-908" data-mp="1pczdft398rw0">
              Indien na vier revisierondes nog geen overeenstemming is bereikt,
              kan Noord Digital besluiten de opdracht naar billijkheid af te
              ronden of de samenwerking te beëindigen. In dat geval blijven
              reeds verrichte werkzaamheden in bezit van Noord Digital. Noord
              Digital is niet aansprakelijk voor gevolgen verbonden aan het
              beëindigen van de samenwerking.
            </p>
            <p data-id="element-909" data-mp="11kiy3qawje0e">
              Nadat de wederpartij akkoord geeft op het design voor de website
              staat Noord Digital in zijn recht de aanbetaling te behouden.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-910" data-mp="388j8z9w01ogj">
              Artikel 20: Resultaten en garanties (SEO, performance, marketing)
            </h3>
            <p data-id="element-911" data-mp="3h9zjdhmtdqkr">
              Noord Digital kan geen garanties geven voor resultaten buiten haar
              invloedssfeer. Dit geldt in het bijzonder voor (maar is niet
              beperkt tot):
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-912" data-mp="2pjcy291g615a">
              <li data-id="element-913" data-mp="2pgqgdgkue59c">Posities in zoekmachines (SEO-resultaten);</li>
              <li data-id="element-914" data-mp="2tlgc95fi3ju9">
                Bezoekersstatistieken, conversieratio's of marketing-KPI's;
              </li>
              <li data-id="element-915" data-mp="2yhyenyncz63f">
                Omzet, leads of rendement uit advertenties of
                marketingcampagnes;
              </li>
              <li data-id="element-916" data-mp="33c2jab95j21c">
                Laadsnelheid of performance in specifieke browsers en op alle
                apparaten;
              </li>
              <li data-id="element-917" data-mp="2asvno06u40w9">
                Compatibiliteit met toekomstige softwareversies of -platforms
                van derden.
              </li>
            </ul>
            <p data-id="element-918" data-mp="cc3m8pe7dqk1">
              Elke bepaling of indicatie over dit soort resultaten is dan ook
              indicatief en niet bindend.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-919" data-mp="q4beq4ygevcx">
              Artikel 21: Domeinnamen en e-mail
            </h3>
            <p data-id="element-920" data-mp="laozq64tifdy">
              Als partij die domeinnamen registreert, treedt Noord Digital
              slechts op als bemiddelaar of wederverkoper via externe
              registrars. De Opdrachtgever blijft te allen tijde zelf
              verantwoordelijk voor keuze, gebruik en actualisering van
              domeinnamen (registratie, verlenging, verhuizing, etc.).
            </p>
            <p data-id="element-921" data-mp="151k9l8myuh9e">
              Noord Digital is niet aansprakelijk voor intrekking, verlies,
              verloop of weigering van een domeinnaam, noch voor merkrechtelijke
              geschillen rondom domeinnamen. Evenmin voor fouten of vertragingen
              die registrars of registries maken. Fouten in e-mailinstellingen
              of verlies van e-mail door derde partijen vallen eveneens buiten
              onze verantwoordelijkheid.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-922" data-mp="2mxcku7xilt8e">
              Artikel 22: Beëindiging van de Overeenkomst
            </h3>
            <p data-id="element-923" data-mp="2rvnvulzjq9s7">
              Beide partijen kunnen de Overeenkomst beëindigen bij wezenlijke
              tekortkoming door de wederpartij. Onder wezenlijke tekortkoming
              valt onder meer: niet of niet tijdig betalen van facturen, het
              niet nakomen van belangrijke contractbepalingen, of het onmogelijk
              maken van een normale voortgang. Voorbehoudt uitdrukkelijk dat
              sprake moet zijn van een tekortkoming die niet binnen een daartoe
              gestelde redelijke hersteltermijn wordt verholpen.
            </p>
            <p data-id="element-924" data-mp="7689c37d178d">
              Noord Digital mag de Overeenkomst met onmiddellijke ingang
              beëindigen of opschorten als de Opdrachtgever niet aan zijn
              betalingsverplichtingen voldoet, in staat van faillissement wordt
              verklaard, surseance van betaling aanvraagt of anderszins
              insolvent raakt. In dat geval is Noord Digital gerechtigd alle
              (lopende en nog niet betaalde) werkzaamheden af te ronden en
              onmiddellijk de volledige overeengekomen vergoeding in rekening te
              brengen.
            </p>
            <p data-id="element-925" data-mp="jh8x78lqzl77">
              Als de Overeenkomst beëindigd wordt, blijft de Opdrachtgever
              aansprakelijk voor alle reeds verrichte werkzaamheden en gemaakte
              kosten tot de datum van beëindiging. Dit geldt zowel bij
              beëindiging door de Opdrachtgever als door Noord Digital.
            </p>
            <p data-id="element-926" data-mp="178o4zgwamupu">
              Bij beëindiging van onderhouds- of hostingdiensten kan de
              Opdrachtgever verzoeken om migratie of overdracht van de website
              en data naar een andere leverancier. Noord Digital voert een
              dergelijke migratie slechts uit tegen vergoeding (meerwerk) en pas
              nadat alle openstaande facturen zijn voldaan.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-927" data-mp="1jo4bqej4qwl8">
              Artikel 23: Aansprakelijkheid
            </h3>
            <p data-id="element-928" data-mp="1ompae9iqh87k">
              Noord Digital is alleen aansprakelijk voor directe schade die het
              rechtstreekse en exclusieve gevolg is van een aan Noord Digital
              toe te rekenen tekortkoming in de uitvoering van de Overeenkomst.
            </p>
            <p data-id="element-929" data-mp="22hhwxrx1jonn">
              Indirecte schade en gevolgschade, zoals gederfde winst,
              omzetverlies, gemiste besparingen, bedrijfsschade,
              reputatieschade, verlies van data of klanten, is uitdrukkelijk
              uitgesloten. Ook is Noord Digital niet aansprakelijk voor schade
              door claims van derden (bijv. wegens hackers of datalekken) als
              hiervoor in redelijkheid de Opdrachtgever verantwoordelijk is.
            </p>
            <p data-id="element-930" data-mp="2xq304q3osyuq">
              Indien Noord Digital aansprakelijk wordt gehouden, is de
              schadevergoeding beperkt tot het bedrag dat de Opdrachtgever in de
              12 maanden voorafgaand aan het schadeveroorzakende incident aan
              Noord Digital heeft betaald voor de betreffende dienst. Indien
              Noord Digital een lagere verzekeringsuitkering ontvangt voor deze
              schade, geldt dat verzekeringsbedrag als maximum.
            </p>
            <p data-id="element-931" data-mp="2spyk116oy651">
              Eventuele claims of vorderingen tot schadevergoeding vervallen als
              zij niet binnen 12 maanden na ontdekking van de schade
              schriftelijk bij Noord Digital zijn gemeld.
            </p>
            <p data-id="element-932" data-mp="208mdmgmohj9u">
              Bovenstaande beperkingen en uitsluitingen gelden niet voor schade
              veroorzaakt door opzet of grove schuld (bewuste roekeloosheid) van
              Noord Digital. In zulke gevallen is Noord Digital aansprakelijk
              conform de wettelijke regels.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-933" data-mp="fktiqibupst1">
              Artikel 24: Overmacht
            </h3>
            <p data-id="element-934" data-mp="1q0w6zxjnccy">
              Noord Digital is niet aansprakelijk voor het niet, niet tijdig of
              niet volledig nakomen van verplichtingen indien dit het gevolg is
              van omstandigheden buiten haar macht ("overmacht"). Onder
              overmacht wordt in ieder geval verstaan: internetstoringen; uitval
              van servers, stroom of netwerk; DDoS-aanvallen en andere
              cyberincidenten; storingen bij (cloud)hostingpartijen, registrars
              of softwareleveranciers; pandemieën, overheidsmaatregelen, brand,
              oorlog of onverwachte calamiteiten.
            </p>
            <p data-id="element-935" data-mp="3a7nkixe85e3l">
              Bij overmacht mag Noord Digital haar verplichtingen opschorten
              zolang de toestand van overmacht voortduurt. Als de (dreigende)
              overmacht langer dan twee maanden voortduurt, is elke partij
              bevoegd de Overeenkomst te ontbinden zonder dat er recht op
              schadevergoeding ontstaat.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-936" data-mp="2k16babrhtqqr">
              Artikel 25: Deelbaarheid
            </h3>
            <p data-id="element-937" data-mp="3cromy16a90fs">
              Indien een of meer bepalingen van deze Algemene Voorwaarden nietig
              of vernietigbaar blijken te zijn, tast dit niet de geldigheid van
              de overige bepalingen aan. Partijen verplichten zich in dat geval
              in goed overleg een nieuwe, geldige regeling ter vervanging
              overeen te komen die zoveel mogelijk de strekking van de
              oorspronkelijke bepaling benadert.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-938" data-mp="1rd0rpsc6e7si">
              Artikel 26: Privacy en AVG
            </h3>
            <p data-id="element-939" data-mp="1wb2988tydz1v">
              Noord Digital verwerkt persoonsgegevens in overeenstemming met de
              Algemene Verordening Gegevensbescherming (AVG) en de
              Uitvoeringswet AVG.
            </p>
            <p data-id="element-940" data-mp="nghupn69vfuu">
              Wanneer Noord Digital in het kader van de dienstverlening
              persoonsgegevens verwerkt voor rekening van de Opdrachtgever,
              treedt Noord Digital op als verwerker. Indien de wet dit vereist,
              wordt hiervoor een aparte verwerkersovereenkomst gesloten met de
              Opdrachtgever (art. 28 AVG).
            </p>
            <p data-id="element-941" data-mp="3mtinu9ujkzrc">
              De Opdrachtgever is zelf verantwoordelijk voor de rechtmatige
              verwerking van persoonsgegevens via de geleverde website of
              software (bijv. privacyverklaring, toestemmingen,
              beveiligingsmaatregelen). Noord Digital kan hiertoe advies geven,
              maar de (eind)verantwoordelijkheid blijft bij de Opdrachtgever.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-942" data-mp="343ax6r8141s1">
              Artikel 27: Toepasselijk recht en geschillen
            </h3>
            <p data-id="element-943" data-mp="1c32n6yyq3bkd">
              Op alle rechtsbetrekkingen tussen Partijen is uitsluitend het
              Nederlands recht van toepassing. Dit betekent dat de Nederlandse
              wet, inclusief het Burgerlijk Wetboek, de
              Richtlijnen/Verordeningen van de EU (zoals de eIDAS/AVG), en de
              jurisprudentie van Nederlandse rechters rechtskracht hebben.
            </p>
            <p data-id="element-944" data-mp="t46rtkb4or4y">
              Geschillen die voortvloeien uit de Overeenkomst of deze Algemene
              Voorwaarden zullen bij uitsluiting worden voorgelegd aan de
              bevoegde rechter in het arrondissement Noord-Holland (plaatselijk
              bevoegde rechtbank), tenzij dwingend recht anders voorschrijft.
              Partijen doen hiermee uitdrukkelijk afstand van het recht
              eventuele geschillen in het buitenland te laten beslechten.
            </p>

            <h2 className="text-3xl font-bold mt-16 mb-6 border-b pb-4" data-id="element-945" data-mp="2ug2kn2w1rby">
              Service Level Agreement (SLA) (Hosting en Support)
            </h2>
            <ul className="list-disc pl-6 space-y-2" data-id="element-946" data-mp="3u1slb6jf6ctz">
              <li data-id="element-947" data-mp="3p9r4r8f7xzy5">
                <strong data-id="element-948" data-mp="3p98z5l6o29dk">Werkdagen:</strong> ma–vr, 09:00–17:00; geen
                weekend/feestdagen.
              </li>
              <li data-id="element-949" data-mp="3kaxnd4wt9osp">
                <strong data-id="element-950" data-mp="3k9d2y847nm8k">SLA-reactietijden (streefwaarden):</strong>
                <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-951" data-mp="3fdo0nx0t3r8k">
                  <li data-id="element-952" data-mp="3b9zpl4cyudik">Kleine wijzigingen: reactie binnen 3 werkdagen.</li>
                  <li data-id="element-953" data-mp="36berpbl6s5xa">Middelgrote wijzigingen: reactie binnen 5 werkdagen.</li>
                  <li data-id="element-954" data-mp="36dit9mvm4sue">
                    Kritieke storingen (website offline): eerste reactie binnen
                    1 werkdag.
                  </li>
                </ul>
              </li>
              <li data-id="element-955" data-mp="14ja0y3ffbeo5">
                <strong data-id="element-956" data-mp="zkytu0giji9m">Beveiliging & Monitoring:</strong> Firewall en
                malware-scans worden continu toegepast; netwerk- en
                infrastructuur-monitoring op servers. Updates voor CMS en
                plugins worden maandelijks doorgevoerd. Nieuwe
                veiligheidsmaatregelen worden geïmplementeerd op afroep.
              </li>
              <li data-id="element-957" data-mp="3je8wgbjoho43">
                <strong data-id="element-958" data-mp="3jgv8andlqps4">Back-ups:</strong> Dagelijks (24 uurs interval) worden
                back-ups gemaakt van websitebestanden en databases. Bij storing
                in onze hostingomgeving wordt een back-upherstel uitgevoerd.
                Voor herstelkosten zie artikel 11.
              </li>
              <li data-id="element-959" data-mp="3ehiko0ewpeoh">
                <strong data-id="element-960" data-mp="30oj6q2urvsj1">Support:</strong> Ondersteuning vindt plaats via e-mail
                of ticketing (geen telefonische helpdesk). 24/7 support kan
                desgewenst worden ingekocht.
              </li>
            </ul>

            <h2 className="text-3xl font-bold mt-16 mb-6 border-b pb-4" data-id="element-961" data-mp="2qreg9qtw9awf">
              Aanbiedingsclausule en administratieve afhandeling
            </h2>
            <p data-id="element-962" data-mp="2c3eho2h56e59">
              In de offerte of opdrachtbevestiging dient de volgende tekst te
              worden opgenomen:
            </p>
            <blockquote className="bg-gray-50 p-4 border-l-4 border-[#007AFF] italic my-4" data-id="element-963" data-mp="282ug8mpjcodb">
              "Deze offerte en alle daaruit voortvloeiende overeenkomsten zijn
              onderworpen aan de Algemene Voorwaarden van Noord Digital. Door
              ondertekening van deze offerte verklaart Opdrachtgever de Algemene
              Voorwaarden ontvangen te hebben (als bijlage of via [link naar
              pdf]) en hiermee akkoord te gaan."
            </blockquote>

            <p data-id="element-964" data-mp="34sbkcx8ve2cw">
              Daarnaast kan in de acceptatiemail of in het digitale contract het
              volgende worden opgenomen:
            </p>
            <blockquote className="bg-gray-50 p-4 border-l-4 border-[#007AFF] italic my-4" data-id="element-965" data-mp="2zv1xnpcv84sr">
              "Met het ondertekenen van dit document verklaart ondergetekende
              deze Algemene Voorwaarden te hebben gelezen, kunnen opslaan en
              onvoorwaardelijk te aanvaarden. Volgens Verordening (EU) 910/2014
              (eIDAS) heeft een (gekwalificeerde) elektronische handtekening
              dezelfde rechtsgevolgen als een handgeschreven handtekening."
            </blockquote>

            <p data-id="element-966" data-mp="3qqpng93p3rb7">
              Een voorbeeld van een handtekeningregel voor een (papieren)
              opdrachtbevestiging:
            </p>
            <div className="bg-gray-50 p-6 rounded-lg my-4 font-mono text-sm" data-id="element-967" data-mp="4dpra8jxsx95">
              <p data-id="element-968" data-mp="8e9plfg8y6wv">________________________________________________________</p>
              <p data-id="element-969" data-mp="8ge4esfooqbx">
                [Naam opdrachtgever, Functie]
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                Datum: _________
              </p>
            </div>

            <p data-id="element-970" data-mp="2f60ynbgp34lo">
              Bij digitale accordering volstaat bijvoorbeeld: "Ik ga akkoord met
              de Algemene Voorwaarden van Noord Digital."
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-971" data-mp="2cl31fzlyhsi0">
              Implementatie en controle
            </h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-972" data-mp="27tky54wgnftv">
              <li data-id="element-973" data-mp="27s06bn1j6azp">
                <strong data-id="element-974" data-mp="22ui5yl1kx43b">Terhandstelling:</strong> Zorg dat de Algemene
                Voorwaarden vóór of bij het sluiten van de overeenkomst
                beschikbaar zijn. Bij voorkeur: PDF als bijlage bij de offerte,
                of link naar pdf in de e-mail met offerte. Op deze wijze kan de
                Opdrachtgever de voorwaarden opslaan, wat vereist is om ze
                juridisch geldig te maken volgens art. 6:235 BW. De gebruiker
                heeft dan "redelijke mogelijkheid" gehad om ze te bestuderen.
              </li>
              <li data-id="element-975" data-mp="2glmx0yqvso21">
                <strong data-id="element-976" data-mp="2go946x9v11jq">Expliciet akkoord:</strong> Laat de klant bij (digitaal)
                ondertekenen expliciet verklaren dat hij de AV heeft ontvangen
                en accepteert. Bijvoorbeeld door een checkbox ("Ik bevestig dat
                ik de Algemene Voorwaarden van Noord Digital heb ontvangen en ga
                akkoord") of door ondertekening van de offerte zelf. Dit biedt
                bewijs bij een eventuele geschil.
              </li>
              <li data-id="element-977" data-mp="1lvs1pamaalq9">
                <strong data-id="element-978" data-mp="1lw9u1w5tsfsw">Bewijsstukken bewaren:</strong> Archiveer de offerte,
                opdrachtbevestiging, e-mails, facturen en ander correspondentie
                zorgvuldig. Bewaar het document waarin de Opdrachtgever akkoord
                gaat met de AV. Deze kunnen dienen als bewijs van
                rechtsgeldigheid volgens art. 6:227 BW.
              </li>
              <li data-id="element-979" data-mp="24sjhha2maipk">
                <strong data-id="element-980" data-mp="24t2qu2e7byrz">Offerte sjabloon:</strong> Zorg dat het offerte- of
                ordersjabloon een clausule bevat waarin melding wordt gemaakt
                van de toepasselijkheid van deze voorwaarden (zie voorbeeldtekst
                hierboven). Gebruik bij voorkeur een formele passage
                "Ondertekend door [naam], in [plaats]".
              </li>
              <li data-id="element-981" data-mp="puxdv3v12mc4">
                <strong data-id="element-982" data-mp="pufaln9y77up">Check lijst:</strong> Controleer bij elke nieuwe klant
                of deze geen formele Beroeps- of handelsvereniging of ander
                orgaan heeft (bijv. IFPI, ggz) die afwijkende regels oplegt. Pas
                dan de voorwaarden aan waar nodig.
              </li>
            </ul>
          </div>
        </div>
      </main>

      <Footer data-id="element-983" data-mp="6wktsn2kvs1r" />
    </div>;
}